module.exports = __webpack_public_path__ + "media/events/buyingShows-ccb46c0c.jpg";